import React, { useState } from 'react'
import { LoginForm } from '../components/auth/login_form'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { setCurrentUser } from '../actions/user'
import { axiosPost } from '../util/api'
import { reloadPage } from '../util/reload'
import { Toasts } from '../components/toaster/Toast'

const login419ReloadKey = 'login-419-reload-attempted'

export const Login = ({}) => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false)

    const login = (email, password, remember) => {
        setLoading(true)
        axiosPost(
            'login',
            {
                email,
                password,
                remember,
            },
            true,
        )
            .then((res) => {
                sessionStorage.removeItem(login419ReloadKey)
                setLoading(false)
                dispatch(setCurrentUser(res.data))
                Toasts.success('Login successful')
                if (res?.data?.keys) {
                    navigate('/dashboard')
                    return
                }
                navigate('/onboard')
            })
            .catch((res) => {
                setLoading(false)

                if (res?.response?.status === 419 && !sessionStorage.getItem(login419ReloadKey)) {
                    sessionStorage.setItem(login419ReloadKey, '1')
                    reloadPage()
                    return
                }

                console.log(res)
            })
    }

    return (
        <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
            <LoginForm onSubmit={login} loading={loading} />
        </div>
    )
}
